export default function getTagDefinitions(): string[] {
  return [
    'HK034',
    'HK118',
    'HK119',
    'HK120',
    'HK121',
    'HK122',
    'HK123',
    'HK124',
    'HK143',
    'HK144',
    'HK174',
    'HK182',
    'HK503',
    'HK504',
    'HK505',
    'HK509',
    'HK512',
    'HK515',
    'HK516',
    'HK517',
    'HK518',
    'HK519',
    'HK520',
    'HK521',
    'HK522',
    'HK523',
    'HK524',
    'HK525',
    'HK526',
    'HK527',
    'HK528',
    'HK529',
    'HK530',
    'HK531',
    'HK532',
    'HK533',
    'HK536',
    'HK034',
    'TP-007-AKGL',
    'PK05',
    'PK17',
    'HK133',
    'HK542',
    'HK547',
    'HK732',
    'HK742',
    'HK775',
    'HK534',
    'HK535',
    'HK539',
    'HK541',
    'HK544',
    'HK546',
    'HK548',
    'HK688',
    'HK689',
    'K68',
    'PK03',
    'SV6000',
    'SVG100',
    'SVG102',
    'SVG103',
    'SVG104',
    'SVG105',
    'SVG106',
    'SVG107'
  ];
}
